import React, { useState, useEffect } from 'react';
import useStyles from '../indexcss';
import { Card, Grid, Box, Button, Typography } from '@mui/material';
import KenAccordion from '../../../../GlobalComponents/KenAccordion';
import { FAQItem, FAQResponse } from '../../../../interfaces/Service';
import { getFaq } from '../../../../Utils/apiService';

interface SubQuestionProps {
  question: string;
  answer: string;
}
const SubQuestion: React.FC<SubQuestionProps> = ({ question, answer }) => {
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  const answerContent = (
    <>
      <Box component={'div'} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={toggleExpansion}>
        <Button sx={{ marginRight: { lg: '8px' }, color: expanded ? '#3061FF' : '#000', fontSize: { xs: '16px' }, fontWeight: expanded ? '600' : '500' }}>{expanded ? '-' : '+'}</Button>
        <Box className={classes.fontsubq} sx={{ color: expanded ? '#3061FF' : '#000' }}>
          {question}
        </Box>
      </Box>
      {expanded && (
        <div
          color="inherit"
          //  onClick={() => navigate('/service/Answers', { state: { subquestion: subquestion, answer: answer } })}
        >
          <div className={classes.fontsuba}>{answer}</div>
        </div>
      )}
    </>
  );

  return (
    <div
      className={classes.subquestion}
      style={{
        backgroundColor: expanded ? '#EAEFFF' : 'transparent',
        cursor: expanded ? 'pointer' : 'default',
      }}
    >
      {answerContent}
    </div>
  );
};
const FAQ = () => {
  const classes = useStyles();
  const [searchInput, setSearchInput] = useState('');
  const [faqData, setFaqData] = useState<FAQItem[] | undefined>();

  useEffect(() => {
    console.log('ashdgahsd');

    getFaq()
      .then(async (res: FAQResponse) => {
        console.log('res343', res);

        if (res?.success) {
          setFaqData(res.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  console.log('faqData', faqData);

  const filteredQuestions = faqData?.filter(
    (question: any) => question.question.toLowerCase().includes(searchInput.toLowerCase()) || question.category.toLowerCase().includes(searchInput.toLowerCase())
  );

  const groupedFAQ = filteredQuestions?.reduce((acc: any, item: any) => {
    if (!acc[item?.category]) {
      acc[item?.category] = [];
    }
    acc[item?.category].push(item);
    return acc;
  }, {});
  console.log('groupedFAQ12', groupedFAQ);

  const CustomLabel = ({ text }: { text: string }) => (
    <Typography
      sx={{
        fontSize: '15px',
        fontWeight: '550',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
          fontSize: '11px !important',
        },
      }}
    >
      {text}
    </Typography>
  );
  return (
    <Card className={`${classes.cardDesign1} scrollbar-cusgray`}>
      <div className={`${classes.customScrollbarContainer1} scrollbar-cusgray`}>
        {groupedFAQ &&
          Object.entries(groupedFAQ).map(([category, items]: any) => {
            return (
              <KenAccordion key={category} label={<CustomLabel text={category} />}>
                <Grid container spacing={2}>
                  {items.map((item: { id: React.Key | null | undefined; question: string; answer: string }) => (
                    <Grid item key={item.id} xs={12}>
                      <SubQuestion question={item.question} answer={item.answer} />
                    </Grid>
                  ))}
                </Grid>
              </KenAccordion>
            );
          })}
      </div>
    </Card>
  );
};

export default FAQ;
